import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-gs-whats-happening',
	templateUrl:'./WhatsHappeningPage.html',
	styles: [],
	styleUrls:['./WhatsHappeningPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaCardDirective,
],
	standalone:true
})
export class WhatsHappeningPage
{
}
